export * from "./administration.component";
export * from "./administration.module";


// WEBPACK FOOTER //
// ./src/app/administration/index.ts